var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttributesOverridesGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4899_109487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 10.8571V13.7142H20.7407L18.1481 16.5714V25.1428H7.77778V5.14279H18.1481L20.7407 2.28564H1.2963C0.648148 2.28564 0 2.85707 0 3.71422V26.5714C0 27.2856 0.518519 27.9999 1.2963 27.9999H24.6296C25.2778 27.9999 25.9259 27.4285 25.9259 26.5714V7.99993L23.3333 10.8571ZM5.18519 25.1428H2.59259V22.2856H5.18519V25.1428ZM5.18519 19.4285H2.59259V16.5714H5.18519V19.4285ZM5.18519 13.7142H2.59259V10.8571H5.18519V13.7142ZM5.18519 7.99993H2.59259V5.14279H5.18519V7.99993ZM23.3333 25.1428H20.7407V22.2856H23.3333V25.1428ZM23.3333 19.4285H20.7407V16.5714H23.3333V19.4285Z",
    fill: "#008662"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6304 15.4286H13.8711V11.4286L23.9822 0.285784C24.3711 -0.142787 24.8896 -0.142787 25.2785 0.285784L27.7415 3.00007C28.1304 3.42864 28.1304 4.00007 27.7415 4.42864L17.6304 15.4286Z",
    fill: "#008662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4899_109487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributesOverridesGreen);
export default __webpack_public_path__ + "static/media/Attributes-Overrides-Green.3238b9ea3a386b928bd030be8de0ece4.svg";
export { ForwardRef as ReactComponent };